import {Component, Input, HostListener, OnDestroy, OnInit} from '@angular/core';

import { SortableService } from '../sortable.service';


@Component({
  moduleId: module.id,
  selector: 'sortable-component, [sortable]',
  templateUrl: 'sortable.component.html',
  styleUrls: ['sortable.component.scss'],
})
export class SortableComponent implements OnInit {

  @Input() sortableField: string;
  @Input() active: boolean = false;
  isAsc: boolean = false; // true - ascendingly, false - descendingly

  constructor(
    private sortableService: SortableService
  ) {}

  ngOnInit() {
    this.sortableService.add(this);
  }

  setActive(active: boolean) {
    this.active = active;
    if (!this.active) {
      this.isAsc = false;
    }
  }
  @HostListener('click') onClick() {
    this.isAsc = this.active ? !this.isAsc : true;
    this.sortableService.sortBy(this.sortableField, this.isAsc);
  }
}
